<template>
	<nav>
		<router-link to="/" class="site-name">B<span class="desktop">ecca</span> & D<span class="desktop">ylan</span></router-link>

		<div class="menu" :class="this.mobileNavOpen ? 'menu--open' : 'menu--closed'">
			<router-link to="events">Events</router-link>
			<router-link to="travel">Travel</router-link>
			<router-link to="registry">Registry</router-link>
			<router-link to="faqs">FAQ<span class="lowercase">s</span></router-link>
			<button class="menu_close-button" @click="toggleMobileMenu"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="32" height="32"><path d="M7.719 6.281 6.28 7.72 23.563 25 6.28 42.281l1.44 1.439L25 26.437 42.281 43.72l1.438-1.438L26.437 25 43.72 7.719 42.28 6.28 25 23.563Z" fill="#FFF"/></svg></button>
		</div>

		<button class="mobile-menu-trigger" @click="toggleMobileMenu"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="32" height="32"><path d="M0 9v2h50V9Zm0 15v2h50v-2Zm0 15v2h50v-2Z" fill="#000"/></svg></button>
	</nav>
</template>

<script>
export default {
	data() {
		return {
			mobileNavOpen: false
		}
	},
	methods: {
		toggleMobileMenu() {
			this.mobileNavOpen = !this.mobileNavOpen
		}
	},
  watch: {
    $route (to, from) {
      if (this.mobileNavOpen === true) {
        if (to.path !== from.path) {
          this.mobileNavOpen = false
        }
      } else {
        return
      }
    }
  }
}
</script>

<style lang="scss" scoped>
nav {
	align-items: center;
	background-color: $color-neutral-400;
	border-bottom: $border-900-md;
	display: flex;
	justify-content: space-between;
	padding: $space-2;
	position: -webkit-sticky;
	position: sticky;
	top: 0;
	z-index: 1;

	@include min-width(desktop) {
		padding: $space-2 $space-5;
	}
}

.site-name {
	font-family: $type-display;
	font-size: 28px;
	line-height: .9;
	margin: 0;
	text-decoration: none;
	text-transform: uppercase;

	&:hover {
		text-decoration: none;
	}

	.desktop {
		display: none;

		@include min-width(desktop) {
			display: inline-block;
		}
	}
}

.menu {
	background-color: rgba(0,0,0,1);
	display: flex;
	flex-direction: column;
	right: 0;
	position: fixed;
	top: 0;
	transition: all 0.2s ease-out;
	z-index: 1;

	@media screen and (max-width: 833px) {
		&--open {
			opacity: 1;
			height: 100vh;
			padding: $space-3;
			width: 220px;
		}

		&--closed {
			opacity: 0;
			height: 0;
			padding: 0;
			width: 0;
		}
	}

	@include min-width(tablet) {
		background-color: transparent;
		position: unset;
		flex-direction: row;
	}

	a {
		color: $color-shade-100;
		font-family: $type-sans;
		font-weight: 300;
		text-decoration: none;
		text-transform: uppercase;

		&+a {
			margin: $space-4 0 0 0;

			@include min-width(tablet) {
				margin: 0 0 0 $space-4;
			}
		}

		@include min-width(tablet) {
			color: $color-shade-900;
		}
	}

	.menu_close-button {
		background-color: transparent;
		border: none;
		position: absolute;
		right: $space-2;
		top: $space-2;

		@include min-width(tablet) {
			display: none;
		}
	}
}

.mobile-menu-trigger {
	background-color: transparent;
	border: none;

	@include min-width(tablet) {
		display: none;
	}
}
</style>